import React, { useState } from 'react';
import { useTemplate } from '../../../features/template/TemplateProvider';
import { ButtonCancel, ButtonPrimary } from '../../../utils/Button';
import FocusControl from '../../../utils/FocusControl';
import InputField, { InputPassword } from '../../../utils/InputField';
import { useAdminListInfo } from '../AdminList/AdminsListProvider';
import { ApiCreateNewAdmin } from '../AdminsPageOperation';

function AdminCreateNewUser({ closeModal }) {
    const { setReloadKey } = useAdminListInfo();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        Role: 'admin',
        FirstName: '',
        LastName: '',
        Email: '',
        Phone: '',
        Password: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((d) => ({ ...d, [name]: value }));
    };
    const { setMessage } = useTemplate();
    const handleCreateNewAdmin = (e) => {
        setLoading(true);
        e.preventDefault();
        ApiCreateNewAdmin(formData, setIsError)
            .then(({ title }) => {
                setLoading(false);
                setMessage({ type: 'success', text: title });
                closeModal();
                setReloadKey((d) => d + 1);
            })
            .catch((error) => {
                setLoading(false);
                setMessage({ type: 'error', text: error.toString(0) });
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleCreateNewAdmin} className="flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Smith"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="flex flex-col sm:flex-row  justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="Email"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Phone Number"
                    name="Phone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <InputPassword
                label="Default Password"
                name="Password"
                placeholder='e.g. "********"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <p className="text-sm text-error/90 font-normal leading-6 mb-3">
                Password must contain at least 1 Letter, 1 Number & 1 Symbol. Minimum length is 8
                characters.
            </p>
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                <ButtonPrimary title="Create" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default AdminCreateNewUser;
